import React, { useState, useEffect } from "react";

function CustomStep({ preferredMotoType, onChangeCustomStep }) {
  // State to track form data dynamically
  const [formData, setFormData] = useState({});

  // Sync form data changes with parent component
  useEffect(() => {
    if (onChangeCustomStep) {
      onChangeCustomStep(formData);
    }


  }, [formData, onChangeCustomStep]);

  // Handle form input changes
  const handleChange = (category, fieldName, value) => {

    setFormData(prevData => ({
      ...prevData,
      [category]: {
        ...(prevData[category] || {}),
        [fieldName]: value
      }
    }));
  };

  // Render input based on field type
  const renderInput = (category, fieldName, config) => {
    const value = formData[category]?.[fieldName] || '';

    switch (config.type) {
      case 'enum':
        return (
          <select
            name={fieldName}
            value={value}
            required={config.required}
            onChange={(e) => handleChange(category, fieldName, e.target.value)}
            className="w-full p-2 border rounded text-black"
          >
            <option value="">Select {fieldName}</option>
            {config.options?.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        );

      case 'file':
        return (
          <input
            type="file"
            name={fieldName}
            required={config.required}
            onChange={(e) => {
              const file = e.target.files?.[0];
              handleChange(category, fieldName, file);
            }}
            className="w-full p-2 border rounded"
          />
        );

      case 'number':
        return (
          <input
            type="number"
            name={fieldName}
            value={value}
            required={config.required}
            onChange={(e) => handleChange(category, fieldName, e.target.value)}
            className="w-full p-2 border rounded text-black"
          />
        );

      default:
        return (
          <input
            type="text"
            name={fieldName}
            value={value}
            required={config.required}
            onChange={(e) => handleChange(category, fieldName, e.target.value)}
            className="w-full p-2 border rounded text-black"
          />
        );
    }
  };

  // Render dynamic form sections
  const renderFormSections = () => {
    if (!preferredMotoType?.extra) return null;

    return Object.entries(preferredMotoType.extra).map(([category, fields]) => (
      <div key={category} className="mb-6">
        <h3 className="text-lg font-semibold mb-4">{category}</h3>
        {Object.entries(fields).map(([fieldName, fieldConfig]) => (
          <div key={fieldName} className="mb-4">
            <label className="block mb-2">
              {fieldConfig.name}
              {fieldConfig.required && <span className="text-red-500">*</span>}
            </label>
            {renderInput(category, fieldName, fieldConfig)}
          </div>
        ))}
      </div>
    ));
  };

  return (
    <div className="p-6   rounded">
      <form>
        {renderFormSections()}
      </form>
    </div>
  );
}

export default CustomStep;